<template>
  <div class="container">
    <div class="cont">
      <img
        src="../../assets/img/mxk_bg.png"
        style="width: 100%"
        class="img"
        alt=""
      />
    </div>
    <div class="inputGrpup">
      <div class="bgWhite">
        <div class="phone_sty">
          <img src="../../assets/img/hx.png" alt="">
          <span>您的朋友({{phone}})邀请你注册</span>
          <img src="../../assets/img/hx.png" alt="">
        </div>
        <van-cell-group>
          <van-field
            class="lister phone"
            type="tel"
            v-model="form.phone"
            @keydown.native="keyDown($event)"
            maxlength="11"
            @input="
              (value) => {
                form.phone = value.replace(/[^\d]+/g, '');
              }
            "
            placeholder="请输入手机号"
          />
          <van-field
            class="lister psw"
            :type="seePsw ? 'password' : 'text'"
            @input="
              (value) => {
                form.password = value.replace(/[^\w_]/g, '');
              }
            "
            v-model="form.password"
            placeholder="请设置8~16位数字+字母组合密码"
          >
            <template #button>
              <div @click="handSeePsw">
                <img
                  src="../../assets/img/bieyes.png"
                  style="width: 15px"
                  v-show="seePsw == true"
                />
                <img
                  src="../../assets/img/eyes.png"
                  style="width: 15px"
                  class="see"
                  v-show="seePsw == false"
                />
              </div>
            </template>
          </van-field>
          <van-field
            class="lister code2"
            v-model="form.verifyCode"
            maxlength="6"
            @input="
              (value) => {
                form.verifyCode = value.replace(/[^\d]+/g, '');
              }
            "
            placeholder="请输入验证码"
          >
            <template #button>
              <div class="code">
                <div class="codeGroup">
                  <div>|</div>
                  <div class="subCondeGrpup">
                    <span
                      @click="start"
                      class="codeTxt"
                      v-show="timeStatus == '0001'"
                      >获取验证码</span
                    >
                    <div v-show="timeStatus == '0000'" class="sub">
                      <van-count-down
                        ref="countDown"
                        millisecond
                        :time="time"
                        :auto-start="false"
                        format="ss"
                        @finish="finish"
                      />&nbsp;&nbsp;&nbsp; 秒后重试
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </van-field>
          <van-field
              class="lister phone"
              v-model="form.commendCode"
              label="推荐码"
              label-width="50px"
              readonly
            />
        </van-cell-group>
        <div class="bottom-button">
          <van-button
            color="#2C68FF"
            block
            @click="submit"
            class="btn"
            :loading="loading"
          >
            立即注册
          </van-button>
          <div class="info">
            注册即同意
            <span class="agreement" @click="handServeAgreementsUrl"
              >《用户服务协议》</span
            >
            <span>和</span>
            <span class="agreement" @click="handPrivateAgreementUrl">
              《隐私政策》
            </span>
          </div>
          <van-button
            block
            class="btn"
            @click="handDlownload"
            style="color: #2C68FF"
          >
            立即下载
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { isPoneAvailable } from "@/assets/js/common";
import { Field } from "vant";
import { Button } from "vant";
import { CellGroup } from "vant";
import { Toast, CountDown, Form } from "vant";

import { shareUrl, baseUrl } from "@/assets/js/api";

Vue.use(Field);
Vue.use(Button);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(CountDown);
Vue.use(Form);
export default {
  data() {
    return {
      isDisabled: "0000",
      time: 60000,
      timeStatus: "0001", //0001的话显示倒计时  0000显示倒计时
      value: "",
      seePsw: true,
      url: "https://spapps-api.hkrt.cn/app-api", //公共地址
      // 需要提交的数据
      form: {
        phone: "", //手机号码
        password: "", //密码
        verifyCode: "", //验证码
        commendCode: "", //推荐码
        appTag: 0, //类型 appTag  0 佳付通  1 富裕钱包
      },
      loading:false,
      phone:'',//邀请人手机号
    };
  },
  created() {
    document.title = "注册";
    let commendCode = this.$route.query.commendCode || sessionStorage.getItem("commendCode");
    if(!!commendCode){
      this.form.commendCode = commendCode;
      sessionStorage.setItem("commendCode", commendCode);
    }
    let phone = this.$route.query.phone || sessionStorage.getItem("phone");
    if(!!phone){
      this.phone = phone;
      sessionStorage.setItem('phone',phone);
    }
    // 判断是否回显上次输入的值
    if(this.$route.query.isBack && this.$route.query.isBack=='0000'){
      this.getInfos();
    }
  },
  methods: {
    // 获取信息
    getInfos(){
      let { phone,password } = this.$store.state.shareInfos
      this.form.password = password;
      this.form.phone = phone;
    },

    // 存储到vuex
    vuexStorage(){
      this.$store.commit("setShareInfo",this.form)
    },


    keyDown(e) {
      if (e.keyCode == 32) {
        e.returnValue = false;
      }
    },
    handSeePsw() {
      this.seePsw = !this.seePsw;
    },
    //隐私政策
    handPrivateAgreementUrl() {
      this.vuexStorage()
      this.$router.push({
        name: "mxkPrivateAgreement",
        query:{
          entryMode:'back'
        }
      });
    },
    //用户服务协议
    handServeAgreementsUrl() {
      this.vuexStorage()
      this.$router.push({
        name: "mxkAerveAgreement",
        query:{
          entryMode:'back'
        }
      });
    },
    // handDlownload() {
    //   this.$router.push({
    //     name: "download",
    //     query:{
    //       appTag:this.form.appTag,
    //       commendCode:this.form.commendCode,
    //     }
    //   });
    // },
    handDlownload() {
      this.$router.push({
        name: "appDownload",
      });
    },
    start() {
      if (this.form.phone == "") {
        Toast("手机号不能为空");
        return false;
      }

      if (isPoneAvailable(this.form.phone) == false) {
        Toast("手机号输入有误");
        return false;
      }
      // 0001代表不让点击

      if (this.isDisabled == "0001") {
        console.log("不让点击");
        return false;
      }
      this.isDisabled = "0001";
      let obj = {
        phone: this.form.phone,
        commendCode: this.form.commendCode,
        appTag:this.form.appTag
      };
      baseUrl("/message/v1/webSend", obj)
        .then((res) => {
          this.isDisabled = "0000";
          if (res.data.code == "0000") {
            this.timeStatus = "0000";
            this.$refs.countDown.start();
          } else {
            Toast(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.isDisabled = "0000";
        });
    },
    pause() {
      this.$refs.countDown.pause();
    },
    reset() {
      this.$refs.countDown.reset();
    },
    finish() {
      this.timeStatus = "0001";
      this.reset();
    },
    //   注册按钮点击
    submit() {
      if (this.form.phone == "") {
        Toast("手机号不能为空");
        return false;
      }
      if (isPoneAvailable(this.form.phone)) {
        Toast("手机号格式有误");
        return false;
      }
      if (this.form.password == "") {
        Toast("密码不能为空");
        return false;
      }
      if (this.form.password.length < 8 || this.form.password.length > 16) {
        Toast("密码长度为8-16位");
        return false;
      }

      let regp = /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$/;

      if (!regp.test(this.form.password)) {
        Toast("密码得包含数字和字母");
        return false;
      }

      if (this.form.verifyCode == "") {
        Toast("验证码不能为空");
        return false;
      }
      this.loading = true;
      baseUrl("/userBase/v1/webRegister", this.form)
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.data.code == "0000") {
            // 跳转到下载页面
            this.handDlownload();
          }
          Toast(res.data.msg);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.container {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  margin: 0 auto;
  max-width: 500px;
  height: 100vh;
  background: #075EE2;
  overflow:hidden
}
.cont {
  margin: 0 auto;
}
.img {
  width: 100%;
}
.inputGrpup {
  padding: 0 15px;
  box-sizing: border-box;
  position: absolute;
  top: 31.5%;
  width: 100%;
}
.bgWhite {
  background: #fff;
  padding: 5px 15px 20px;
  border-radius: 15px;
}
div /deep/ .van-cell {
  border:0;
  border-bottom: 1px solid #EBEBEB;
  padding:12px 7px
}

[class*=van-hairline]::after,.van-cell::after{
  content: none;
}
.title{
  font-size: 28px;
  font-weight: bold;
  padding-left: 20px;
  padding-top: 20px;
}

div /deep/ .van-count-down {
  line-height: inherit;
  color: #2C68FF;
}
.see {
  transform: translateY(3px);
}
.code {
  color: #2C68FF;
  display: flex;
}
div /deep/ .btn {
  border-radius: 44px;
}
.info {
  font-size: 13px;
  text-align: center;
  margin: 16px 0 15px;
}
.agreement {
  color: #2C68FF;
}
.codeGroup {
  width: 80px;
  display: flex;
  justify-content: space-between;
}
.subCondeGrpup {
  display: flex;
  justify-content: center;
  width: 100%;
}
.sub {
  display: flex;
}
.codeTxt {
  cursor: pointer;
}
.van-button--default{
  border:1px solid #2C68FF;
}
.bottom-button{
  margin-top: 25px;
}
.phone_sty{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333;
  padding-top: 13px;
  padding-bottom: 10px;
}
.phone_sty span{
  padding: 0 5px;
}
.phone_sty img{
  width: 33px;
  height: 1px;
}
.lister /deep/ .van-field__label{
  color: #323233;
}
@media screen and (max-width:375px){
  /* .inputGrpup {
    top: 35.5%;
  } */
  .phone_sty{
    font-size: 12px;
  }
}
/* @media screen and (min-width:400px){
  .inputGrpup {
    top: 35.5%;
  }
} */
/* @media screen and (min-height:750px) {
  .inputGrpup {
    top: 30%;
  }
} */
</style>